import React from "react";
import { ButtonLink } from "./ButtonRouterLinkStyle";

const ButtonRouterLink = () => {
  return (
     <ButtonLink to="/AndroidClub" >HOME</ButtonLink>
  );
};

export default ButtonRouterLink;
